import moment from 'moment';
import { DadoSimulacaoSeguro } from './dado-simulacao-seguro';
import { PropostaSimulacao } from './proposta/proposta-simulacao';
import { PeriodicidadePagamentoEnum } from '../../../../produtos/shared/enums/periocidade-pagamento.enum';

export class DadoSimulacao {

  private _carencia = 0;

  get carencia(): number {
    return this._carencia;
  }
  set carencia(value: number) {
    this._carencia = value;
  }

  numeroProposta: string;
  ultimaDataTaxa: number = Date.now();
  parcelas = 0;
  primeiraParcela: number;
  periodicidadePagamento?: number;
  prazoMezes?: number;
  valor = 0;
  cotacao = 0;
  seguro: DadoSimulacaoSeguro = new DadoSimulacaoSeguro();
  parcelasSelecionar: Map<number, number> = new Map();
  entradaPorcentagem = 0;
  dias = 30;
  periodicidadeAnterior: number;

  constructor() {
    this.primeiraParcela = moment()
      .add(this.dias, 'days')
      .unix();
  }

  setParcelas(parcelas: number) {
    this.parcelas = parcelas;
  }

  setPrimeiraParcela(primeiraParcela: number) {
    this.primeiraParcela = primeiraParcela;
    this.calculaCarencia();
  }

  setPrimeiraParcelaFlexivel(periodicidadePagamento: number) {
      const diasSemanal = 7;
      const diasDecendial = 10;
      const diasQuinzenal = 14;
      const diasMensal = 30;

      const diasPorPeriodicidade = {
        [PeriodicidadePagamentoEnum.SEMANAL]: diasSemanal,
        [PeriodicidadePagamentoEnum.DECENDIAL]: diasDecendial,
        [PeriodicidadePagamentoEnum.QUINZENAL]: diasQuinzenal,
        [PeriodicidadePagamentoEnum.MENSAL]: diasMensal,
      };

      const novaQtdDias = diasPorPeriodicidade[periodicidadePagamento] ?? diasMensal;

      const periodicidadeAnterior = this.periodicidadeAnterior ?? null;
      const periodicidadeMudou = periodicidadePagamento !== periodicidadeAnterior;

      this.dias = novaQtdDias;
      this.periodicidadeAnterior = periodicidadePagamento;


      if (this.primeiraParcela && !periodicidadeMudou) {
        const dataAtual = moment.unix(this.primeiraParcela);
        if (dataAtual.isValid()) {
          this.calculaCarencia();
          return;
      }
    }

    this.primeiraParcela = moment()
      .add(this.dias, 'days')
      .unix();

    this.calculaCarencia();
  }

  setPeriodicidadePagamento(periodicidadePagamento: number){
    this.periodicidadePagamento = periodicidadePagamento;
  }

  setPrazoMezes(prazoMezes: number){
    this.prazoMezes = prazoMezes;
  }

  private calculaCarencia() {
    const dataCalculada = moment().add(this.dias, 'day');
    const dataPrimeiraParcela = moment.unix(this.primeiraParcela);
    const hora: any = { hour: 0, minute: 0, second: 0, millisecond: 0 };
    dataCalculada.set(hora);
    dataPrimeiraParcela.set(hora);
    this.carencia = dataPrimeiraParcela.diff(dataCalculada, 'days');
  }

  init(proposta: PropostaSimulacao) {
    this.numeroProposta = proposta.getId();
    this.parcelas = proposta.getTaxaClinte().getParcelas();
    this.cotacao = proposta.getCotacaoVeiculo();
    this.valor = proposta.getTaxaClinte().getValorLiberado();
  }

  setCotacao(cotacao: number) {
    this.cotacao = cotacao;
  }

  getCarencia(): number {
    return this.carencia;
  }

  setNumeroProposta(numeroProposta: string) {
    this.numeroProposta = numeroProposta;
  }

  getNumeroProposta(): string {
    return this.numeroProposta;
  }

  getUltimaDataTaxa(): number {
    return this.ultimaDataTaxa;
  }

  getParcelas(): number {
    return this.parcelas;
  }

  setValor(valor: number) {
    this.valor = valor;
  }

  getValor(): number {
    return this.valor;
  }

  setSeguro(seguro: DadoSimulacaoSeguro) {
    this.seguro.setRetorno(seguro.retorno);
    this.seguro.gruposSeguroIds = seguro.gruposSeguroIds;
    this.seguro.setGrupoAssistenciaIds(seguro.gruposAssistenciaIds[0], 0);
  }

  getSeguro(): DadoSimulacaoSeguro {
    return this.seguro;
  }

  setEntradaPorcentagem(entradaPorcentagem: number) {
    this.entradaPorcentagem = entradaPorcentagem;
  }

  getEntradaPorcentagem(): number {
    return this.entradaPorcentagem;
  }

  getPeriodicidadePagamento(): number{
    return this.periodicidadePagamento;
  }

  getPrazoMezes(): number{
    return this.prazoMezes;
  }
}
